import { Link, useLocation } from 'react-router-dom';
import { MessageSquare, HelpCircle } from 'lucide-react';
import { Button } from './ui/button';

/**
 * CTA Component for contact/support on category and listing pages
 * Pre-fills contact form with category, search query, and URL
 */
const ContactCTA = ({ category = '', searchQuery = '' }) => {
  const location = useLocation();
  
  // Build URL params for pre-filling contact form
  const buildContactUrl = () => {
    const params = new URLSearchParams();
    if (category) params.set('category', category);
    if (searchQuery) params.set('search', searchQuery);
    params.set('from', location.pathname);
    return `/contact?${params.toString()}`;
  };

  return (
    <div className="bg-gradient-to-r from-slate-50 to-slate-100 border border-slate-200 rounded-2xl p-6 sm:p-8 my-8 sm:my-12">
      <div className="flex flex-col sm:flex-row items-center gap-6">
        <div className="flex-shrink-0">
          <div className="w-14 h-14 sm:w-16 sm:h-16 bg-indigo-100 rounded-xl flex items-center justify-center">
            <HelpCircle className="w-7 h-7 sm:w-8 sm:h-8 text-indigo-600" />
          </div>
        </div>
        <div className="flex-1 text-center sm:text-left">
          <h3 className="text-lg sm:text-xl font-bold text-slate-900 mb-2">
            Besoin d'une pièce spécifique ?
          </h3>
          <p className="text-slate-600 text-sm sm:text-base">
            Vous ne trouvez pas la référence exacte ? Envoyez-nous votre demande via le formulaire et nous vous répondrons par email.
          </p>
        </div>
        <div className="flex-shrink-0">
          <Link to={buildContactUrl()}>
            <Button 
              size="lg" 
              className="bg-indigo-600 hover:bg-indigo-700 text-white font-semibold gap-2"
              data-testid="contact-cta-btn"
            >
              <MessageSquare className="w-5 h-5" />
              Contacter le support
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ContactCTA;
